import { TextField as MUITextField } from "@mui/material";
import React from "react";

const TextField = (props) => {
  return <MUITextField {...props} />;
};

export default TextField;
